import React from "react";
import './styles.scss'
import { ISkills } from "../../Interfaces/ISkills";
import CardItem from "../CardItem";

interface CardSkillProps {
    title: string
    itens: ISkills[]
    corArea: string
}

const CardSkil = ({ title, itens, corArea }: CardSkillProps) => {
const filteredSkills = itens
.filter(item => item.hasOwnProperty('skill'))
.map(item => item.skill)
.join(',');
console.log(filteredSkills)
    return ((itens.length > 0) ?
        <div className="CardSkillContainer">
            <div className="CardSkillTitle" style={{ color: corArea, borderBottom: `2px solid ${corArea}` }}>
                <h4>{title}</h4>
            </div>
            <div className="skill">
                <img src={`https://skillicons.dev/icons?i=${filteredSkills}&perline=5`} alt={title} />
            </div>
        </div>
        : <></>
    )
}
export default CardSkil